import { IconButton, InputAdornment, OutlinedInput } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import CloseIcon from "@material-ui/icons/Close";
import SearchIcon from "@material-ui/icons/Search";
import useDebounce from "../../../../util/useDebounce";

export const StyledOutlinedInput = styled(OutlinedInput)`
  background-color: rgba(228, 235, 239, 0.5);
  height: 2.25rem;
  font-size: 1rem;
  border-radius: 0.325rem;
  padding-left: 0.375rem;
  padding-right: 0.375rem;
  transition: background-color 0.125s ease-in-out;

  .MuiSvgIcon-root {
    width: 1.325rem;
    height: 1.325rem;
    transition: opacity 0.125s ease-in-out;
    opacity: 0.5;
  }

  .MuiOutlinedInput-notchedOutline {
    opacity: 0;
  }

  &:hover {
    background-color: rgba(228, 235, 239, 0.75);
  }

  &.Mui-focused {
    background-color: rgba(228, 235, 239, 0.05);

    .MuiSvgIcon-root {
      opacity: 1;
    }

    .MuiOutlinedInput-notchedOutline {
      opacity: 1;
    }
  }
`;

const DEFAULT_DEBOUNCE_TIME = 500;

interface IDebouncedSearchFieldProps {
  // ref?: React.Ref<HTMLInputElement>;
  initialValue: string;
  placeholder: string;
  onDebouncedChange: (newSearchTerm: string) => void;
  debounceTime?: number;
}

const DebouncedSearchField = React.forwardRef(
  (props: IDebouncedSearchFieldProps, ref) => {
    const { initialValue, placeholder, onDebouncedChange } = props;
    const [searchTerm, setSearchTerm] = useState(initialValue);

    const debouncedTime = props.debounceTime ?? DEFAULT_DEBOUNCE_TIME;
    const debouncedValue = useDebounce(searchTerm, debouncedTime);
    useEffect(() => {
      onDebouncedChange(debouncedValue);
    }, [debouncedValue, onDebouncedChange]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      setSearchTerm(e.target.value);
    };

    const handleReset = () => {
      setSearchTerm("");
    };

    return (
      <StyledOutlinedInput
        inputRef={ref}
        placeholder={placeholder}
        onChange={handleChange}
        value={searchTerm}
        startAdornment={
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        }
        fullWidth
        endAdornment={
          searchTerm !== "" ? (
            <InputAdornment position="end">
              <IconButton onClick={handleReset}>
                <CloseIcon />
              </IconButton>
            </InputAdornment>
          ) : undefined
        }
      />
    );
  }
);

export default DebouncedSearchField;
